import React from 'react';
import { createPortal } from 'react-dom';
import { useRealizedGainLoss } from '../../../../hooks/useRealizedGainLoss';
import { Totals } from './components/Totals/Totals';
import { InvestmentTable } from './components/InvestmentTable/InvestmentTable';
import { RealizedGainLossTabLoading } from './RealizedGainLossTab.loading';
import { InvestmentTableEmpty } from './components/InvestmentTable/InvestmentTable.empty';
import { ErrorState } from '../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ActivityCsvExport } from '../../../../components/ActivityCsvExport/ActivityCsvExport';
import { useExportCsvButtonContainer } from '../../../../hooks/useExportCsvButtonContainer';

export const RealizedGainLossTab = () => {
  const exportCsvButtonContainer = useExportCsvButtonContainer();

  return (
    <>
      {!!exportCsvButtonContainer &&
        createPortal(<ActivityCsvExport tab="rgl" />, exportCsvButtonContainer)}

      <RealizedGainLossTabContent />
    </>
  );
};

export const RealizedGainLossTabContent = () => {
  const { data, isFetching, isError, refetch } = useRealizedGainLoss();

  if (isFetching) {
    return <RealizedGainLossTabLoading />;
  }

  if (isError) {
    return (
      <Box display="flex" flex="1" alignItems="center" justifyContent="center">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return (
      <>
        <Totals />

        <InvestmentTableEmpty />
      </>
    );
  }

  return (
    <>
      <Totals realizedGainsLossDataList={data} />

      <InvestmentTable investments={data} />
    </>
  );
};
